import styled from "styled-components";

import themes from "../../themes";

interface CardClientProps {
  temaCard?: any;
  temaCardFont?: any;
}

export const Container = styled.aside<CardClientProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 320px;
  height: 200px;

  background-size: cover;
  background-position: center;
  border-radius: 10px;

  img {
    position: absolute;
    top: 20px;
    right: 15px;
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
`;

export const Content = styled.div<CardClientProps>`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  margin-top: 80px;
  padding-left: 23px;
  position: relative;

  h6,
  p {
    font-family: "Bai Jamjuree", sans-serif;
    font-weight: 600;
    color: ${(props) =>
      props.temaCardFont
        ? props.temaCardFont
        : themes.components.colors.cardText};
  }

  h6 {
    font-size: 18px;
    letter-spacing: 1.13px;
    line-height: 5px;
  }

  p {
    font-size: 14px;
    letter-spacing: 0.88px;
    line-height: 22px;
    padding-top: -20px;
  }
`;
